import { DBT_DEFAULT_LINE, DBT_LINES, type DbtLine, dbtVersionOf } from "@auradata/contracts";

/** "1.12 · dbt 1.12.4": the line the customer picks and the exact version it runs today. */
export function dbtLineLabel(line: DbtLine): string {
  const tags = [
    line === DBT_DEFAULT_LINE ? "latest" : null,
    DBT_LINES[line].retires ? `retires ${retiresOn(line)}` : null,
  ].filter(Boolean);
  return `${line} · dbt ${dbtVersionOf(line)}${tags.length ? ` (${tags.join(", ")})` : ""}`;
}

/** The sentence under the picker: what changes on its own and what never does. */
export function dbtLineHint(line: DbtLine): string {
  const retires = DBT_LINES[line].retires;
  if (retires)
    return `This line retires on ${retiresOn(line)}; projects still on it move to the next line then. Patch releases inside a line apply with the next runner image.`;
  return "Patch releases inside a line apply with the next runner image; moving to another line is your call.";
}

function retiresOn(line: DbtLine): string {
  const d = DBT_LINES[line].retires;
  if (!d) return "";
  return new Date(`${d}T00:00:00Z`).toLocaleDateString("en-US", {
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}
